export const form_data = {
  ifsc: "IFSC Code",
  gst: "GST Number*",
  company: "Company Name*",
  company_address: "Company Address*",
  gst_company_city: "Company City*",
  gst_reg: "I am GST registered",
  fullName: "Full name*",
  pan_number: "PAN Number",
  pan_full_name: "Full name as on PAN card*",
  pan_dob: "Date of birth as on PAN card*",
  AccNum: "Account number*",
  Pincode: "Pincode*",
  AccType: "Account type*",
  BankNum: "Bank name*",
};

export const CONTRACT_STATUS = "contract_status";

export const BANK_DETAIL_FILEDS = {
  fullName: "full_name",
  accountNumber: "account_number",
  accountType: "account_type",
  bankName: "bank_name",
  ifscCode: "ifsc_code",
  billingState: "billing_state",
};

export const FIELD_MIN_MAX_LENGTH = {
  minLength: 2,
  maxLength: 200,
};

export const BANK_DETAILS_CONTEXT = {
  bank: "bank",
  backgroundColor: "#FFF7DA",
  textColor: "#000",
  text: "Add your PAN and Bank details to initiate seamless automated Payouts.",
  actionText: "Add Bank Details Now",
  elementId: "bank-details-section",
  dashboardBackgroundColor: "#FFAA00",
  dashboardTextColor: "#332200",
};

export const PAN_DETAIL_CONTEXT = {
  pan: "pan",
  backgroundColor: "#FFF7DA",
  textColor: "#000",
  text: "Add your PAN to initiate seamless automated Payouts.",
  actionText: "Add PAN Details Now",
  elementId: "pan-details-section",
  dashboardBackgroundColor: "#FFAA00",
  dashboardTextColor: "#332200",
};

export const TODAY = "today";

export const KYC_DETAIL_CONTEXT = {
  kyc: "kyc",
  backgroundColor: "rgba(191, 38, 0, 1)",
  textColor: "#FFF",
  actionText: "Complete KYC",
  actionLoading: "Loading...",
  elementId: "kyc-details-section",
  dashboardBackgroundColor: "#BF2600",
  dashboardTextColor: "#FFFFFF",
};

export const DEFAULT_BANNER = {
  today: "today",
  day: "day",
  FallbackDay: "45 days",
};

export const KYC_DEADLINE_CONST = {
  MS_IN_DAY: 1000 * 60 * 60 * 24,
  ZERO_DAYS: 0,
};

export const PAGE_SECTION = {
  dashboard: "dashboard",
  details: "details",
};

export const sectionMap = {
  bank: BANK_DETAILS_CONTEXT.elementId,
  pan: PAN_DETAIL_CONTEXT.elementId,
  kyc: KYC_DETAIL_CONTEXT.elementId,
};

export const SECTION_KEY = "section";

export const GST_DETAIL_FIELDS = {
  gstName: "gst_info.gst_name",
  gstNumber: "gst_info.gst_number",
  gstCompanyAddress: "gst_info.gst_company_address",
  gstCity: "gst_info.gst_city",
  gstPincode: "gst_info.pincode",
  gstStatus: "gst_status",
  gstQueryKey: "gstList",
};

export const PAN_DETAIL_FIELDS = {
  panNumber: "pan_number",
  panFullName: "pan_full_name",
  panDob: "pan_dob",
};

export const KYC_STATUS = {
  kycStatus: {
    INITIATED: "INITIATED",
    PENDING: "PENDING",
    EXPIRED: "EXPIRED",
    REJECTED: "REJECTED",
    DELETED: "DELETED",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED",
  },

  contractStatus: {
    COMPLETE: "1",
    FAILED: "2",
  },
};

export const billingStates = [
  { name: "Andhra Pradesh" },
  { name: "Arunachal Pradesh" },
  { name: "Assam" },
  { name: "Bihar" },
  { name: "Chhattisgarh" },
  { name: "Goa" },
  { name: "Gujarat" },
  { name: "Haryana" },
  { name: "Himachal Pradesh" },
  { name: "Jammu and Kashmir" },
  { name: "Jharkhand" },
  { name: "Karnataka" },
  { name: "Kerala" },
  { name: "Madhya Pradesh" },
  { name: "Maharashtra" },
  { name: "Manipur" },
  { name: "Meghalaya" },
  { name: "Mizoram" },
  { name: "Nagaland" },
  { name: "Odisha" },
  { name: "Punjab" },
  { name: "Rajasthan" },
  { name: "Sikkim" },
  { name: "Tamil Nadu" },
  { name: "Telangana" },
  { name: "Tripura" },
  { name: "Uttarakhand" },
  { name: "Uttar Pradesh" },
  { name: "West Bengal" },
  { name: "Andaman and Nicobar Islands" },
  { name: "Chandigarh" },
  { name: "Dadra and Nagar Haveli" },
  { name: "Daman and Diu" },
  { name: "Delhi" },
  { name: "Lakshadweep" },
  { name: "Puducherry" },
];

export const BANK_DETAILS_VALIDATION_MESSAGES = {
  INVALID: "Invalid",
  ACCOUNT_MAX_LENGTH: "Must be 18 characters or less",
  ACCOUNT_MIN_LENGTH: "Must be 9 characters or more",
  INVALID_PINCODE: "Invalid pincode",
  INVALID_IFSC: "Invalid IFSC code",
  IFSC_LENGTH: "IFSC code must be 11 characters",
  INVALID_PAN: "Invalid PAN number",
  INVALID_GST: "Invalid GST number",
};

export const BANK_DETAILS_VALIDATION_CONFIG = {
  ACCOUNT_MAX_LENGTH: 18,
  ACCOUNT_MIN_LENGTH: 9,
  IFSC_LENGTH: 11,
  PINCODE_REGEX: /^[1-9][0-9]{5}$/,
};

export const BANK_DETAILS_MESSAGES = {
  ERROR_WHEN: "error in getting payout details",
  ERROR_OCCURRED_AT:
    "ui/pages/transactions/PayoutDetails/BankDetails.helpers.js",
};

export const GST_DETAILS_MESSAGES = {
  ERROR_WHEN: "error in saving gst details",
  ERROR_OCCURRED_AT:
    "ui/pages/transactions/PayoutDetails/BankDetails.helpers.js",
};

export const GST_LIST_DETAILS_MESSAGES = {
  ERROR_WHEN: "error in fetching gst list details",
  ERROR_OCCURRED_AT:
    "ui/pages/transactions/PayoutDetails/BankDetails.helpers.js",
};

export const PAN_DETAILS_MESSAGES = {
  ERROR_WHEN: "error in saving pan details",
  ERROR_OCCURRED_AT:
    "ui/pages/transactions/PayoutDetails/BankDetails.helpers.js",
};

export const KYC_VERIFICATION_MESSAGES = {
  ERROR_WHEN: "error in initiating kyc verification",
  ERROR_OCCURRED_AT:
    "ui/pages/transactions/PayoutDetails/BankDetails.helpers.js",
};

export const KYC_REFRESH_MESSAGES = {
  ERROR_WHEN: "error in refreshing kyc status",
  ERROR_OCCURRED_AT:
    "ui/pages/transactions/PayoutDetails/BankDetails.helpers.js",
};

export const BANK_DETAILS_NOTIFICATION_CONFIG = {
  VARIANT: "outlined",
  COLOR: "coral_red",
};

export const BANK_DETAILS_STORAGE_KEYS = {
  GST_STATUS: "gst_status",
};

export const BANK_DETAILS_API_METHODS = {
  POST: "POST",
};

export const BANK_DETAILS_STRINGS = {
  TITLE: {
    ACCOUNT_INFO: "Account Information",
    GST_DETAILS: "GST Details",
    DECLARATION: "Declaration",
  },
  SUBTITLE: {
    ACCOUNT_INFO:
      "Fill in details of the bank account in which you want to receive your earnings/payout",
  },
  LABELS: {
    GST_REG: "I am GST Registered",
    INCLUSIVE: "Make prices GST-inclusive",
    EXCLUSIVE: "Exclusive of my GST",
    PRICES_INFO: "All prices I set on offerings will be:",
    BOOKING_PREF: "Booking Preferences",
    ALLOW_GST: "Allow customers to add GST details",
    MANDATORY_STATE: "Make billing state mandatory during booking",
    USEFUL_INFO: "Useful Information",
    TDS_KNOW_MORE: "Know more about TDS",
    TCS_KNOW_MORE: "Know more about TCS",
    LEGAL_ACCESS:
      "I have legal access to this account and have verified all the info before submitting",
    TAX_TERMS: "I have read and agree to the Taxes terms, wherever applicable",
    SAVING: "Saving...",
    SAVE_DETAILS: "Verify and Save details",
  },
  NOTIFICATIONS: {
    LEGAL_CHECKBOX: "Please tick the legal access checkbox",
    TAXES_CHECKBOX: "Please tick the taxes terms checkbox",
    GST_SUCCESS: "Your GST details have been added successfully...",
  },
  EXTERNAL_LINKS: {
    TDS: "https://cleartax.in/s/section-194o",
    TCS: "https://cleartax.in/s/tcs-under-goods-and-services-tax",
  },
};

// TODO: context to be changed when approved/given by akhil
export const KYC_CONTRACT_MODAL_CONTENT = {
  videoSrc: "https://www.youtube.com/embed/JoDjYyAKwKY",
  title: "Complete Your Verification & E-sign",
  desc: "To activate payouts and access all creator services on Exly, as per Govt. guidelines, you'll be required to review and digitally sign the onboarding agreement.",
  bulletPoints: [
    {
      title: "Quick digital verification:",
      description:
        "Complete your Aadhaar-based verification in a few simple steps.",
    },
    {
      title: "Activate payouts:",
      description:
        "Verification helps us securely process earnings to your registered bank account.",
    },
    {
      title: "Review & e-sign your agreement:",
      description:
        "Digitally sign the creator agreement to activate your Exly account.",
    },
    {
      title: "Secure & compliant process:",
      description:
        "Your information is encrypted and processed through our trusted verification partner.",
    },
  ],
  footer: "The process takes only a few minutes to complete.",
};
